export default __webpack_public_path__ + "img/d832f43ebb2feeb54153079c6f970479.jpg";